/**
 * "Ativos e arrendamentos" section copy (ALC-4608): the asset and lease family of ALC-4607. The
 * rows are advisory: they never count toward the checklist progress and never block the close by
 * themselves.
 */
export const atSectionPtBr = {
  title: 'Ativos e arrendamentos',
  subtitle:
    'Controles consultivos de imobilizado, intangíveis e arrendamentos, fora do progresso do checklist. Eles não bloqueiam o fechamento.',
};

export const atSectionEn: typeof atSectionPtBr = {
  title: 'Assets and leases',
  subtitle:
    'Advisory fixed asset, intangible and lease controls, outside the checklist progress. They do not block the close.',
};
